<script setup>
import { RouterView } from 'vue-router'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { onMounted } from 'vue'
import { useNotificationStore } from '@/state/NotificationStore'
import GlobalLoadingBar from './components/library/elements/GlobalLoadingBar.vue'
import { useHead } from '@unhead/vue'

const { setupNotificationStore } = useNotificationStore()

useHead({
  title: 'Ribis CRM',
  link: [
    { rel: 'canonical', href: 'https://ribis.lol/lander' },
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: '/ribis_logos/logoBlack.svg'
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/ribis_logos/fallbackFavicon.png'
    }
  ],
  meta: [
    {
      name: 'description',
      content:
        'Ribis CRM is a powerful solution tailored for Merchant Cash Advance professionals, offering comprehensive automation and streamlined workflow management.'
    },
    { property: 'og:title', content: 'Ribis CRM' },
    { property: 'og:site_name', content: 'Ribis CRM' },
    {
      property: 'og:description',
      content:
        'Ribis CRM is a powerful solution tailored for Merchant Cash Advance professionals, offering comprehensive automation and streamlined workflow management.'
    },
    { property: 'og:url', content: 'https://ribis.lol' },
    { property: 'og:image', content: 'https://ribis.lol/ribis_logos/LogoOG.svg' },
    { property: 'og:type', content: 'website' },
    { name: 'twitter:title', content: 'Ribis CRM' },
    {
      name: 'twitter:description',
      content:
        'Ribis CRM is a powerful solution tailored for Merchant Cash Advance professionals, offering comprehensive automation and streamlined workflow management.'
    },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:image', content: 'https://ribis.lol/ribis_logos/LogoOG.svg' },
    { name: 'robots', content: 'index, follow' }
  ]
})

onMounted(() => {
  setupNotificationStore()
})
</script>
<template>
  <GlobalLoadingBar />
  <RouterView />
  <VueQueryDevtools />
</template>
